import { useTranslation } from "react-i18next";
import Chart from "react-google-charts";
import "./LineOverview.scss";
import FilterContext from "../../Hooks/Context";
import totalOutputQuantity from "../../Assets/Images/total_output.svg";
import defectPercentage from "../../Assets/Images/defectPercentage.svg";
import averageDefectCount from "../../Assets/Images/averagedefectcount.svg";
import downTime from "../../Assets/Images/downtime.svg";
import LineChart from "../LineChart";
import { useHistory } from "react-router-dom";
import { GetData } from "../../Api";
import { ValidateColor } from "../../Hooks/Common";
import { useContext } from "react";
import CustomDonutChart from "../DonutChart/CustomDonutChart";

const lineChartOptions = {
  elements: {
    line: {
      tension: 0.4, // disables bezier curves
    },
  },
  scales: {
    x: {
      display: false,
      ticks: {
        display: false,
      },
    },
    y: {
      ticks: {
        beginAtZero: true,
        display: false
      },
      max: 100,
      min: 0
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgb(255, 255, 255)",
      titleColor: "#000000",
      borderColor: "#eaeaea",
      borderWidth: "1",
      callbacks: {
        labelTextColor: function (context) {
          return "#333333";
        },
      },
    },
  },
};

const lineChartNoDataOptions = {
  elements: {
    line: {
      tension: 0.4, // disables bezier curves
    },
  },
  scales: {
    x: {
      display: false,
      ticks: {
        display: false,
      },
    },
    y: {
      display: false,
      ticks: {
        beginAtZero: true,
        display: false
      },
      max: 100,
      min: 0
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgb(255, 255, 255)",
      titleColor: "#000000",
      borderColor: "#eaeaea",
      borderWidth: "1",
      callbacks: {
        labelTextColor: function (context) {
          return "#333333";
        },
      },
    },
  },
};

const LineOverview = ({ data, getPrinter }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const filterQueries = useContext(FilterContext);

  const lineImages = {
    "LT_total_output_quantity": totalOutputQuantity,
    "LT_defect_percentage": defectPercentage,
    "LT_defect_count": averageDefectCount,
    "Average Defect count in a week": averageDefectCount,
    "LT_downtime": downTime,
  };

  const GenerateChart = (item) => {
    let processValue = parseInt(item.value);
    let processColor = ValidateColor(processValue);

    let chartData = [
      ["Task", item.name],
      [item.name, processValue],
      ["", 100 - processValue],
    ];

    let options = {
      pieHole: 0.6,
      is3D: false,
      hAxis: { textPosition: "none" },
      timeline: { showBarLabels: false },
      colors: [processColor, "#F3F5F9"],
      legend: { position: "none" },
      labels: false,
      tooltip: { isHtml: true },
    };

    return (
      <div className="line-charts">
        <CustomDonutChart series={[item.value]} 
          labels={[item.entityId]} legendPosition="bottom" 
          title={item.value+"%"} showLegend={false}
          width={180} tooltipDisabled={true} fillColors = {[processColor]}/>
          {/* <div className="col-5 factory-overview-item-right line-legend">
          {processValue}%
        </div> */}
        {/* <Chart
          chartType="PieChart"
          width="150px"
          height="150px"
          data={chartData}
          options={options}
        /> */}
      </div>
    );
  };

  const GenerateAreaChart = (item) => {
    let processValue = parseInt(item.value);
    let processColor = ValidateColor(processValue);

    let chartData = [["Date", "Value"]];

    if (item.data.length === 0) return false;

    item.graph &&
      item.graph.map((item, index) => {
        let chartArray = [];
        chartArray.push(index);
        chartArray.push(item);
        chartData.push(chartArray);
      });

    let options = {
      title: "",
      timeline: { showBarLabels: true },
      // For the legend to fit, we make the chart area smaller
      chartArea: { width: "50%", height: "70%" },
      colors: [processColor, "#F3F5F9"],
      legend: { position: "none" },
      labels: true,
      tooltip: { isHtml: true },
      legend: "none",
      animation: {
        startup: true /* Need to add this for animations */,
        duration: 1000,
        easing: "out",
      },
      curveType: "function",
      hAxis: {
        gridlines: {
          color: "transparent",
        },
        baselineColor: "#fff",
        gridlineColor: "transparent",
      },
      vAxis: {
        textStyle: {
          fontSize: 16,
        },
        minValue: 0,
        scaleType: "log",
        gridlines: {
          color: "transparent",
        },
        baselineColor: "#fff",
        gridlineColor: "transparent",
      },
      gridlines: {
        color: "none",
      },
      timeline: {
        groupByRowLabel: true,
        showRowLabels: false,
        showBarLabels: false,
      },
      avoidOverlappingGridLines: false,
      // lineWidth: 25
    };

    return (
      <div className="area-charts">
        <Chart
          width={"350px"}
          height={"80px"}
          chartType="AreaChart"
          loader={<div>Loading Chart</div>}
          data={chartData}
          options={options}
          // For tests
          rootProps={{ "data-testid": "1" }}
        />
      </div>
    );
  };

  const GenerateStatisticsData = (data) => {
    return (
      <div className="line-overview-wrapper">
        {data.statistics &&
          data.statistics.map((item, index) => {
            let processValue = parseInt(item.value);
            let statusColor = ValidateColor(processValue);

            return (
              <div
                key={item.name}
                className="line-overview-card"
              >
                <div className="line-item-image">
                  <img src={lineImages[item.name]} alt={item.name} />
                </div>
                <div className="factory-overview-item-right mobile-full-width">
                  <div className="line-overview-wrapper-item">
                    {item.value === "" ? 0 : item.value}
                  </div>
                  <div className="line-overview-wrapper-sublabel">
                    {t(item.name)}
                  </div>
                  <div className="line-overview-wrapper-range-sublabel target-label">
                    {item.target === "" ? "N/A" : item.target}
                    {item.unit === 'sec'? ' '+item.unit : (item.unit !== 'number' ? item.unit : '')}
                    <br />
                    <div className="line-overview-wrapper-sublabel no-border">
                      {t("LT_target_number")}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  const NavigateView = (entityId) => {
    entityId = entityId === "spi" ? "inspection" : entityId;
    if (entityId !== "pick-place" && entityId !== "reflow") {
      if(filterQueries) {
        let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
        filterRequestQuery.selectedMenu = `#${entityId}`;
        filterQueries.GenerateFilters(filterRequestQuery);
        localStorage.setItem('currentMenu', `#${entityId}`);
      }
      history.push(`/${entityId}`);
    }
  };

  const GenerateLineCards = (data) => {
    return (
      <div className="line-card-container">
        {data.devices &&
          data.devices.map((item, index) => {
            let processValue = parseInt(item.value);
            let statusColor = ValidateColor(processValue);

            return (
              <div
                key={ `item${index}`}
                className={`line-card-container-cards ${
                  item.active == 1 ? "card-active" : "card-inactive"
                }`}
              >
                <div className="line-card-container-cards-content">
                  <div className="line-cards-top">
                    <div className="same-child">
                      <div
                        className="line-card-item-header"
                        style={{ flex: "1" }}
                      >
                        {t(item.name)}
                      </div>
                      <div
                        className="open-report float-right open-reports-link"
                        style={{ flex: "1" }}
                        onClick={() => {
                          NavigateView(item.entityId);
                        }}
                      >
                        { t("LT_open") }
                        <i
                          className={`fa fa-angle-right open-reports-icon`}
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="line-card-chart-container">
                    <div className="line-card-chart-container-left">
                      {GenerateChart(item)}
                    </div>
                    <div className="line-card-chart-container-right">
                      { !item.graph || item.graph.length == 0 && <LineChart
                        lineChartData={item}
                        lineGraphData={[]}
                        name={`lineChart${index}`}
                        options={lineChartNoDataOptions}
                      /> }
                      { item && item.graph && item.graph.length >= 1 && <LineChart
                        lineChartData={item}
                        lineGraphData={item.graph}
                        name={`lineChart${index}`}
                        options={lineChartOptions}
                      /> }
                      {/* <div className='line-overview-wrapper-sublabel nil-border'>{ item.name}</div> */}
                      <div
                        className="line-area-item"
                        style={{ color: statusColor }}
                      >
                        {statusColor === "#3cc480" ? (
                              <i
                                className={`fa fa-arrow-up`}
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className={`fa fa-arrow-down`}
                                aria-hidden="true"
                              ></i>
                            )}&nbsp;{processValue}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className="line-overview">
      {GenerateStatisticsData(data)}
      {GenerateLineCards(data)}
    </div>
  );
};

export default LineOverview;
